export default __webpack_public_path__ + "static/media/5700_sim_bg.2076ab73.png";